import { createFileRoute } from '@tanstack/react-router'

import ManagedServices from '@/features/services/pages/services'

export const Route = createFileRoute('/_shell/services')({ component: ManagedServices })
